"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationBody = exports.notificationKey = exports.rulePayloadFields = exports.smsChannelPayloadFields = exports.emailChannelPayloadFields = exports.mobileChannelPayloadFields = exports.webhookChannelBody = exports.smsChannelBody = exports.emailChannelBody = exports.mobileChannelBody = exports.channelBase = exports.channelKey = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../json"));
const field_1 = require("../../openapi/field");
const notification_1 = require("./notification");
// Plain field records, not schemas: each router composes them with its own owner
// fields and identifier. Kept out of the index so the identifier sweep skips them.
const optionalDateTime = (description) => effect_1.Schema.optionalWith((0, field_1.dateTime)(description), { exact: true }).annotations({ description });
const email = (description) => 
// Domain labels exclude the dot, so the dot-separated groups cannot backtrack into each other.
effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/)).annotations({
    description,
    jsonSchema: { type: 'string', format: 'email' },
});
const optionalUri = (description) => effect_1.Schema.optionalWith(effect_1.Schema.String.annotations({
    description,
    jsonSchema: { type: 'string', format: 'uri' },
}), { exact: true }).annotations({ description });
const optionalChannelName = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
    description: 'Display name',
});
exports.channelKey = {
    channelId: (0, field_1.nonEmpty)('Notification channel id (stored id projected by list)'),
};
exports.channelBase = {
    active: effect_1.Schema.Boolean,
    name: (0, field_1.optionalNullableString)('Display name'),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
};
exports.mobileChannelBody = {
    type: effect_1.Schema.Literal('push_mobile'),
    token: effect_1.Schema.String,
    platform: effect_1.Schema.Literal('ios', 'android'),
    tokenType: effect_1.Schema.optionalWith(effect_1.Schema.Literal('message', 'pass'), { exact: true }),
    deliveryMethod: effect_1.Schema.optionalWith(effect_1.Schema.Literal('fcm'), { exact: true }),
    permKey: (0, field_1.optionalNullableString)('Apple APN permission key'),
};
exports.emailChannelBody = {
    type: effect_1.Schema.Literal('email'),
    email: email('Recipient email'),
};
exports.smsChannelBody = {
    type: effect_1.Schema.Literal('sms'),
    number: effect_1.Schema.String,
};
exports.webhookChannelBody = {
    type: effect_1.Schema.Literal('webhook', 'webhook_svix'),
};
exports.mobileChannelPayloadFields = {
    token: (0, field_1.nonEmpty)('Push token'),
    platform: effect_1.Schema.Literal('ios', 'android'),
    tokenType: effect_1.Schema.optionalWith(effect_1.Schema.Literal('message', 'pass'), { exact: true }),
    deliveryMethod: effect_1.Schema.optionalWith(effect_1.Schema.Literal('fcm'), { exact: true }),
    permKey: (0, field_1.optionalString)('Apple APN permission key'),
    name: optionalChannelName,
};
exports.emailChannelPayloadFields = {
    email: effect_1.Schema.propertySignature(email('Recipient email')).annotations({
        description: 'Recipient email',
    }),
    name: optionalChannelName,
};
exports.smsChannelPayloadFields = {
    number: (0, field_1.nonEmpty)('Recipient phone number'),
    name: optionalChannelName,
};
const ruleFields = {
    channelIds: effect_1.Schema.propertySignature(effect_1.Schema.Array(effect_1.Schema.String)).annotations({
        description: 'Notification channel ids',
    }),
    scope: effect_1.Schema.optionalWith(notification_1.Scope, { exact: true }).annotations({
        description: 'Defaults to device',
    }),
    tenantId: (0, field_1.optionalString)('Required by runtime when scope is tenant'),
    models: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyArray(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Required only for model scope; forbidden for other scopes',
    }),
    deviceSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyArray(effect_1.Schema.String), { exact: true }).annotations({
        description: 'Required for device scope; forbidden for model, tenant and all scopes',
    }),
    triggerType: effect_1.Schema.propertySignature(notification_1.TriggerType),
    triggerEvent: effect_1.Schema.propertySignature(notification_1.TriggerEvent),
    propertyName: (0, field_1.optionalString)('Required for property triggers'),
    valueComparisonOperator: effect_1.Schema.optionalWith(effect_1.Schema.Literal('==', '!=', '<', '>', '<=', '>='), {
        exact: true,
    }).annotations({
        description: 'Required when triggerEvent is on_value_compare. An on_value_change_compare rule without an operator is accepted but never fires. Connection and registry rules fire on on_value_compare only with == or != against online or offline',
    }),
    valueThreshold: effect_1.Schema.optionalWith(Json.Value, { exact: true }).annotations({
        description: 'Required when triggerEvent is on_value_compare. A threshold of 0 or false is stored as null, so the rule compares the value with null instead',
    }),
    occurrenceName: (0, field_1.optionalString)('Required for event, alarm and error triggers'),
    emailSubject: (0, field_1.optionalString)('Email subject template'),
    emailBody: (0, field_1.optionalString)('Email body template'),
    emailTemplateId: (0, field_1.optionalString)('Email template id. Stored only: delivery does not read it, so a rule without emailBody sends an empty email'),
    pushTitle: (0, field_1.optionalString)('Mobile push title template'),
    pushBody: (0, field_1.optionalString)('Mobile push body template'),
    pushImageUrl: optionalUri('Mobile push image URL; runtime validates isURL(). Stored only: the push is sent without the image'),
    smsMessage: (0, field_1.optionalString)('SMS message template'),
    pushMetadata: effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({
        description: 'Stored only: delivery does not read it',
    }),
    webhookMetadata: effect_1.Schema.optionalWith(Json.Record, { exact: true }).annotations({
        description: 'Stored only: delivery does not read it',
    }),
    minInterval: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(60)), { exact: true }),
    gracePeriod: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()), { exact: true }),
    name: (0, field_1.optionalString)('Display name'),
};
exports.rulePayloadFields = {
    ...ruleFields,
    channelIds: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyArray(effect_1.Schema.String)).annotations({
        description: 'At least one notification channel id',
    }),
};
exports.notificationKey = {
    notificationId: (0, field_1.nonEmpty)('Notification id projected from stored id'),
    ruleId: (0, field_1.nonEmpty)('Rule id projected from stored id'),
};
exports.notificationBody = {
    version: effect_1.Schema.optionalWith(effect_1.Schema.Int, { exact: true }),
    active: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
    actionType: (0, field_1.optionalString)('Rule action type'),
    ...ruleFields,
    tenantId: (0, field_1.optionalNullableString)('Tenant id'),
    models: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    deviceSerialNumbers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    propertyName: (0, field_1.optionalNullableString)('Trigger property name'),
    valueComparisonOperator: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Literal('==', '!=', '<', '>', '<=', '>=')), {
        exact: true,
    }),
    valueThreshold: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Value), { exact: true }),
    occurrenceName: (0, field_1.optionalNullableString)('Event, alarm or error occurrence name'),
    emailSubject: (0, field_1.optionalNullableString)('Email subject template'),
    emailBody: (0, field_1.optionalNullableString)('Email body template'),
    emailTemplateId: (0, field_1.optionalNullableString)('Email template id'),
    pushTitle: (0, field_1.optionalNullableString)('Mobile push title template'),
    pushBody: (0, field_1.optionalNullableString)('Mobile push body template'),
    pushImageUrl: (0, field_1.optionalNullableString)('Mobile push image URL'),
    smsMessage: (0, field_1.optionalNullableString)('SMS message template'),
    pushMetadata: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }),
    webhookMetadata: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(Json.Record), { exact: true }),
    gracePeriod: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative())), { exact: true }),
    minInterval: effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()), { exact: true }).annotations({
        description: 'Seconds between notifications. Stored as 0 when not set; delivery then falls back to 60',
    }),
    lastSentAt: optionalDateTime('ISO-8601 time of the last delivery attempt, set by logSent'),
    name: (0, field_1.optionalNullableString)('Display name'),
    createdAt: optionalDateTime('ISO-8601 creation time'),
    updatedAt: optionalDateTime('ISO-8601 last update time'),
};
//# sourceMappingURL=notification-fields.js.map